import PropTypes from "prop-types";
import React from "react";

import Label from '../formsUi/common/label/Label';
import RangeSlider from '../formsUi/rangeSlider/RangeSlider';
import ValidationMessage from '../formsUi/common/validation/ValidationMessage';

const FormRangeSliderControls = ({
    dataField,
    labelName,
    name,
    value,
    error,
    isRequired,
    fieldSetting = {},
    onChange,
}) => {

    const handleRangeChange = (range) => {
        if (onChange) onChange(dataField, range);
    };

    return (
        <>
            <div className="input-label-part">
                {labelName && <Label labelName={labelName} htmlFor={name} isRequired={isRequired} fieldSetting={fieldSetting} />}
                <RangeSlider
                    id={name}
                    value={value}
                    min={fieldSetting?.min}
                    max={fieldSetting?.max}
                    step={fieldSetting?.step}
                    title={labelName}
                    placeholder={fieldSetting?.placeholder}
                    isDisabled={fieldSetting?.isDisable}
                    onChange={handleRangeChange}
                />
            </div>
            <ValidationMessage error={error || ""} />
        </>
    );
};

FormRangeSliderControls.propTypes = {
    dataField: PropTypes.string.isRequired,
    labelName: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    error: PropTypes.string,
    isRequired: PropTypes.bool,
    fieldSetting: PropTypes.shape({
        min: PropTypes.number,
        max: PropTypes.number,
        step: PropTypes.number,
        placeholder: PropTypes.string,
        isDisable: PropTypes.bool,
    }),
    onChange: PropTypes.func,
};

export default FormRangeSliderControls;
